import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'product-pricing-form',
  templateUrl: './product-pricing-form.component.html',
  styleUrls: [
    './product-pricing-form.component.scss',
    '../add-product-single-dialog.component.scss',
  ],
})
export class ProductPricingFormComponent implements OnInit {
  @Input() pricingFormGroup!: FormGroup;
  selectedVat = true;
  isEditable = false;
  displayPrice!: number;
  vatAmount: number = 0; // to allow computation when vat is disabled
  sellingPrice: number = 0; // to allow computation when vat is enabled

  ngOnInit(): void {
    this.pricingFormGroup.valueChanges.subscribe((data) => {
      //Reflect realtime calculation to Displayed Price field ex. Nan+1 = 1
      const vat: number = +`${
        this.pricingFormGroup.get('VatAmount')?.disabled ||
        isNaN(+`${data.VatAmount}`)
          ? this.vatAmount
          : data.VatAmount
      }`;

      // Reflect realtime calculation to Displayed Price field ex. 1+Nan = 1
      const sellingPrice: number = +`${
        isNaN(+`${data.VatAmount}`) && isNaN(+`${data.SellingPrice}`)
          ? this.sellingPrice
          : data.SellingPrice
      }`;

      this.displayPrice = vat + sellingPrice;

      // Formatting number
      this.pricingFormGroup.value.DisplayedPrice =
        this.displayPrice.toLocaleString();
    });
  }

  selectVat() {
    this.pricingFormGroup.get('IsVatable')?.setValue(this.selectedVat);
    if (this.selectedVat) {
      this.pricingFormGroup.get('VatAmount')?.enable();
    } else {
      this.pricingFormGroup.get('VatAmount')?.disable();
    }
  }

  addVat() {
    const vat: number = +`${this.pricingFormGroup.get('VatAmount')?.value}`;
    const sellingPrice: number = +`${
      this.pricingFormGroup.get('SellingPrice')?.value
    }`;

    this.displayPrice = vat + sellingPrice;

    this.pricingFormGroup
      .get('DisplayedPrice')
      ?.setValue(this.displayPrice.toString());
  }
}
